import {Directive, Input, Output, EventEmitter} from '@angular/core';
// import { PostForBoardService } from '../services/post_for_board/post-for-board.service';
import {NGXLogger} from "ngx-logger";


@Directive({
  selector: '[appLoad]'
})
export class LoadDirective {
    @Input() isLast: boolean;

    @Output('appLoad') initEvent: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.check();
    }
    check(){
        if (this.isLast) {
            setTimeout(() => this.initEvent.emit(true),0);
        }
    }

  constructor(
      // private postForBoardService: PostForBoardService,
      private logger: NGXLogger,


  ) {
      // this.postForBoardService.getNewPostEmitter().subscribe(item=>{
      //     if (this.isLast) {
      //         setTimeout(() => this.initEvent.emit(true),2000);
      //     }
      // })
  }

}
